<template>
  <Combobox as="div" v-model="fondsStore.selectedFonds" by="isin">
    <ComboboxLabel class="block text-sm font-medium text-gray-700">Fondsauswahl</ComboboxLabel>
    <div class="relative mt-3">
      <ComboboxInput
        placeholder="Name oder ISIN des Fonds"
        class="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400 sm:text-sm"
        @change="onChangedQuery($event.target.value)"
        :display-value="(person) => person?.name"
      />

      <ComboboxButton
        class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
      >
        <ChevronDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
      </ComboboxButton>

      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-out"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <ComboboxOptions
          v-if="fondsStore.fonds.length > 0"
          class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
        >
          <ComboboxOption
            value="{name:'N/A',isin:0}"
            :disabled="true"
            class="truncate py-2 pl-3 pr-9 text-xs text-gray-500"
          >
            {{ searchText }}
            <!--            {{ searchTerm.value }}-->
            <!--            <span v-if="!searchTerm.value || searchTerm.value === ''"> </span>-->
            <!--            <span v-else>Suche nach: {{ searchTerm.value }} </span>-->
          </ComboboxOption>

          <ComboboxOption
            v-for="person in fondsStore.fonds"
            :key="person.isin"
            :value="person"
            as="template"
            v-slot="{ active, selected }"
          >
            <li
              :class="[
                'relative cursor-default select-none py-2 pl-3 pr-9',
                active ? 'bg-orange-400 text-white' : 'text-gray-900'
              ]"
            >
              <div class="flex">
                <span :class="['truncate', selected && 'font-semibold']">
                  {{ person.name }}
                </span>
                <span
                  :class="[
                    'ml-2 truncate text-gray-500',
                    active ? 'text-orange-200' : 'text-gray-500'
                  ]"
                >
                  {{ person.isin }}
                </span>
              </div>

              <span
                v-if="selected"
                :class="[
                  'absolute inset-y-0 right-0 flex items-center pr-4',
                  active ? 'text-white' : 'text-orange-400'
                ]"
              >
                <CheckIcon class="h-5 w-5" aria-hidden="true" />
              </span>
            </li>
          </ComboboxOption>
        </ComboboxOptions>
      </transition>
    </div>
  </Combobox>
</template>

<script setup lang="ts">
import { CheckIcon, ChevronDownIcon } from '@heroicons/vue/20/solid'
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions
} from '@headlessui/vue'
import { useFondsStore } from '@/stores/fonds'
import { computed, ref } from 'vue'

const fondsStore = useFondsStore()
const searchTerm = ref('')
const searchText = computed(() =>
  !searchTerm.value || searchTerm.value === ''
    ? 'Häufig gesuchte Fonds:'
    : 'Erste 5 Ergebnisse für Suche nach: ' + searchTerm.value
)

function onChangedQuery(newQuery: string) {
  searchTerm.value = newQuery
  if (newQuery !== '' && newQuery !== fondsStore.selectedFonds?.name) {
    fondsStore.searchFonds(newQuery)
  }
}
</script>
